import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ProjectionService, ProjectionCodeParams } from 'src/app/model/api-services/projection.service';
import { TypeAheadPrjRecord } from '../projection-typeahead/projection-typeahead.component';

@Component({
  selector: 'app-projection-by-code',
  templateUrl: './projection-by-code.component.html',
  styleUrls: ['./projection-by-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectionByCodeComponent implements OnInit {

  @ViewChild('auths', { static: true }) auths: ElementRef<HTMLSelectElement>;
  @ViewChild('srid', { static: true }) srid: ElementRef<HTMLInputElement>;

  @Output()
  prjChanged: EventEmitter<TypeAheadPrjRecord> = new EventEmitter<TypeAheadPrjRecord>()
  private _ready = false;
  constructor(private service: ProjectionService, private cdr:ChangeDetectorRef) { }

  searching = false;
  noCode = false;
  ngOnInit(): void {
    this._ready = true;
    this.Refresh();
  }

  CodeEnter(event) {
    this.noCode = false;
    this.Refresh();

    const characterCode = event.which;
    if (characterCode !== 13) {
      return;
    }
    this.CodeChange();
  }

  CodeChange() {
    this.noCode = false;
    this.searching = true;
    this.Refresh();
    const params: ProjectionCodeParams = {
      auth: this.auths.nativeElement.value as 'epsg' | 'esri',
      id: this.srid.nativeElement.value,
      crs: '*',
      sr: true
    };
    this.service.GetByCode(params).then((reply) => {
      this.searching = false;
      this.noCode = reply.response.results.length !== 1;
      this.Refresh();
      if (!!reply.response && !!reply.response.results) {
        if (reply.response.results.length !== 1) {
          return;
        } else {
          const result = reply.response.results[0];
          this.prjChanged.emit(result);
        }
      }
    });
  }
  Refresh() {
    if(this._ready ) {
      this.cdr.detectChanges();
    }
  }

}
